import { NotificationByUser } from 'types/notification';
import { STORAGE_KEY, initialMockNotifications, generateRandomNotification } from './userNotificationData';

// ==================== HELPERS PARA LOCALSTORAGE ====================

export const getStoredNotifications = (): NotificationByUser[] => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
        try {
            return JSON.parse(stored);
        } catch (error) {
            console.error('Error parsing stored notifications:', error);
            return initialMockNotifications;
        }
    }
    return initialMockNotifications;
};

export const saveNotifications = (notifications: NotificationByUser[]): void => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(notifications));
};

// Inicializar localStorage si está vacío
export const initializeStorage = (): void => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
        saveNotifications(initialMockNotifications);
    }
};

// ==================== HANDLERS PARA MUTATIONS ====================

export const handleMarkAsRead = (variables: any): NotificationByUser => {
    const { notificationId } = variables;
    const notifications = getStoredNotifications();
    const index = notifications.findIndex((n) => n.message.id === notificationId);

    if (index === -1) {
        throw new Error(`Notification ${notificationId} not found`);
    }

    notifications[index] = {
        ...notifications[index],
        readAt: Date.now()
    };

    saveNotifications(notifications);
    return notifications[index];
};

export const handleMarkAllAsRead = (): { success: boolean; count: number } => {
    const notifications = getStoredNotifications();
    const now = Date.now();
    let count = 0;

    const updated = notifications.map((n) => {
        if (n.readAt === null) {
            count += 1;
            return { ...n, readAt: now };
        }
        return n;
    });

    saveNotifications(updated);
    return { success: true, count };
};

export const handleTogglePin = (variables: any): NotificationByUser => {
    const { notificationId } = variables;
    const notifications = getStoredNotifications();
    const index = notifications.findIndex((n) => n.message.id === notificationId);

    if (index === -1) {
        throw new Error(`Notification ${notificationId} not found`);
    }

    notifications[index] = {
        ...notifications[index],
        pinned: !notifications[index].pinned
    };

    saveNotifications(notifications);
    return notifications[index];
};

export const handleToggleMute = (variables: any): NotificationByUser => {
    const { notificationId } = variables;
    const notifications = getStoredNotifications();
    const index = notifications.findIndex((n) => n.message.id === notificationId);

    if (index === -1) {
        throw new Error(`Notification ${notificationId} not found`);
    }

    notifications[index] = {
        ...notifications[index],
        muted: !notifications[index].muted
    };

    saveNotifications(notifications);
    return notifications[index];
};

export const handleAddNotification = (): NotificationByUser => {
    const notifications = getStoredNotifications();
    const newNotification = generateRandomNotification();
    const updated = [newNotification, ...notifications];
    saveNotifications(updated);
    return newNotification;
};

// ==================== CALCULAR UNREAD COUNT ====================

export const getUnreadCount = (): number => {
    const notifications = getStoredNotifications();
    return notifications.filter((n) => n.readAt === null).length;
};
